import React, { useEffect, useRef } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { matchQuery } from './utils';

export const useSubscribeQuery = (
  filters: any,
  callback: (state: any) => void
) => {
  const mountedRef = useRef(false) as React.MutableRefObject<boolean>;
  const queryClient = useQueryClient();
  const callbackRef = useRef(() => {}) as React.MutableRefObject<
    (state: any) => void | null
  >;

  callbackRef.current = callback;
  useEffect(() => {
    mountedRef.current = true;

    const unsubscribe = queryClient
      .getQueryCache()
      .subscribe(({ query, action, type }: any) => {
        if (mountedRef.current) {
          if (type === 'updated' && matchQuery(filters, query)) {
            callbackRef.current({
              isFetching: action?.type === 'fetch',
              ...query.state,
            });
          }
        }
      });

    return () => {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [queryClient]);
};
